type RepositionButtonProps = {
  onClick: () => void;
  className?: string;
};
const RepositionButton = ({ onClick, className }: RepositionButtonProps) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="26"
        cy="26"
        r="25"
        fill="black"
        fill-opacity="0.2"
        stroke="white"
      />
      <path
        d="M26 14.5V37.5M37.5 26H14.5"
        stroke="white"
        stroke-linecap="square"
      />
      <path d="M30 18L26 14L22 18" stroke="white" stroke-linecap="square" />
      <path d="M22 34L26 38L30 34" stroke="white" stroke-linecap="square" />
      <path d="M34 30L38 26L34 22" stroke="white" stroke-linecap="square" />
      <path d="M18 22L14 26L18 30" stroke="white" stroke-linecap="square" />
    </svg>
  );
};

export default RepositionButton;
